(ns ui.components.badge.view
  (:require
   [ui.components.badge.zapkit-styles :as styles]
   [ui.components.zapkit-variants :as variants]
   [ui.util :as uu]))

(defn zapkit-class
  "Return the classes of the ZapKit Badge. `variant` is `:primary` (the default),
   `:secondary`, `:destructive`, `:success` or `:on-hold`. `class` is added last."
  [{:keys [variant class]}]
  (uu/cm (variants/slot-class (:root styles/badge)
                              {:variant (or variant :primary)})
         class))

(defn view
  "The ZapKit Badge. `:variant` is one of the variants of `zapkit-class`. `:class`
   is added to the classes of the badge. The children are the content."
  [props & children]
  (into [:span
         (merge (dissoc props :variant :class)
                {:class (zapkit-class props)})]
        children))

(defn danger
  [{:keys [label]}]
  [:span
   {:class "inline-block py-1 px-2 bg-danger-light text-danger-light-text text-xs rounded"}
   label])

(defn warning
  [{:keys [label]}]
  [:span
   {:class "inline-block py-1 px-2 bg-warning-light text-warning-light-text text-xs rounded"}
   label])

(defn success
  [{:keys [label]}]
  [:span
   {:class "inline-block py-1 px-2 bg-success-light text-success-light-text text-xs rounded"}
   label])

(defn neutral
  "For a state that is simply what it is - neither good news nor a problem.
   Without it, an ordinary in-progress status has to borrow `warning` and reads
   as something the user should act on."
  [{:keys [label]}]
  [:span
   {:class "inline-block py-1 px-2 bg-base-light-border-paler text-base-light-text-lighter text-xs rounded"}
   label])
